import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface AccessDeniedProps {
  usuario: any;
  ticket: any;
}

export default function AccessDenied({ usuario, ticket }: AccessDeniedProps) {
  return (
    <div className="text-center py-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Acesso Negado</h2>
      <p className="text-gray-600 mb-6">
        {!usuario 
          ? 'Você precisa estar logado para acessar esta página.'
          : !ticket 
          ? 'Ticket não encontrado ou você não tem permissão para acessá-lo.'
          : 'Você não tem permissão para acessar este ticket.'
        }
      </p>
      <Link to="/" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Voltar aos Tickets
      </Link>
    </div>
  );
}
